import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { noop } from 'lodash';
import { makeSupportClickRecovery } from './intercomSupportClickRecovery';
export const makeMockIntercomClient = ()=>({
        boot: ()=>Promise.resolve(),
        shutdown: noop,
        showNewMessage: noop,
        update: noop,
        hideIntercom: noop,
        showIntercom: noop,
        isLoaded: ()=>false,
        reportBootSkipped: noop,
        enableSupportClickDiagnostics: noop
    });
export const makeMockIntercomClientWithJest = function makeMockIntercomClientWithJest() {
    let { isLoaded = ()=>false, hideIntercom = jest.fn(), boot = jest.fn().mockResolvedValue(undefined), shutdown = jest.fn(), reportBootSkipped = jest.fn(), enableSupportClickDiagnostics = jest.fn() } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        boot,
        shutdown,
        showNewMessage: jest.fn(),
        update: jest.fn(),
        hideIntercom,
        showIntercom: jest.fn(),
        isLoaded,
        reportBootSkipped,
        enableSupportClickDiagnostics
    };
};
export const makeMockIntercomClientWithRealSupportClickRecovery = (param)=>{
    let { supportClickEnv, boot, shutdown } = param;
    const widget = makeMockIntercomClientWithJest({
        boot,
        shutdown,
        isLoaded: ()=>true
    });
    const armed = {};
    let recovery;
    return _object_spread_props(_object_spread({}, widget), {
        showNewMessage: ()=>{
            widget.showNewMessage();
            recovery === null || recovery === void 0 ? void 0 : recovery.observeClick();
        },
        enableSupportClickDiagnostics: (param)=>{
            let { requestHeal, canHeal, getUserId } = param;
            armed.requestHeal = requestHeal;
            armed.canHeal = canHeal;
            armed.getUserId = getUserId;
            recovery !== null && recovery !== void 0 ? recovery : recovery = makeSupportClickRecovery({
                env: supportClickEnv,
                requestHeal: ()=>{
                    var _ref;
                    var _armed_requestHeal;
                    return (_ref = (_armed_requestHeal = armed.requestHeal) === null || _armed_requestHeal === void 0 ? void 0 : _armed_requestHeal.call(armed)) !== null && _ref !== void 0 ? _ref : Promise.resolve();
                },
                canHeal: ()=>{
                    var _ref;
                    var _armed_canHeal;
                    return (_ref = (_armed_canHeal = armed.canHeal) === null || _armed_canHeal === void 0 ? void 0 : _armed_canHeal.call(armed)) !== null && _ref !== void 0 ? _ref : false;
                },
                reopenMessenger: ()=>widget.showNewMessage(),
                isWidgetLoaded: ()=>widget.isLoaded(),
                getUserId: ()=>{
                    var _armed_getUserId;
                    return (_armed_getUserId = armed.getUserId) === null || _armed_getUserId === void 0 ? void 0 : _armed_getUserId.call(armed);
                }
            });
        }
    });
};
